import * as React from 'react'
import { Toaster as Sonner } from 'sonner'

import { useDetectTheme } from '../hooks'
import {
  CheckCircleSolid,
  ExclamationCircleSolid,
  InformationCircleSolid,
  X,
} from '../icons'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const theme = useDetectTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground-normal group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          title: 'group-[.toast]:text-foreground-normal text-base',
          description: 'group-[.toast]:text-muted-foreground text-sm',
          actionButton: '!rounded-lg !h-8 !px-3 !bg-background-inverse',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground !rounded-lg !h-8 !px-3',
        },
      }}
      icons={{
        success: <CheckCircleSolid className="h-5 w-5" />,
        info: <InformationCircleSolid className="h-5 w-5" />,
        warning: (
          <ExclamationCircleSolid className="h-5 w-5 text-foreground-warning" />
        ),
        error: (
          <ExclamationCircleSolid className="h-5 w-5 text-foreground-warning" />
        ),
        close: <X className="h-3 w-3" />,
      }}
      {...props}
    />
  )
}

export { Toaster }
